// @ts-nocheck
// Page: consent-pay  (payment-required consent — subscription + disclosure + payment)
//
// Ported from the inline <script> in
//   Enrollment_modules/consent-pay/form.module/module.html (lines 291–3804).
//
// MECHANICAL PORT — runtime behaviour is preserved. Deliberate changes:
//   1. 5 inline event handlers stripped from markup and re-bound root-scoped
//      via bind() at end of init (ACH/CreditCard radio, softCheck checkbox,
//      subscription/disclosure preview anchors).
//   2. enrollment.nautilussolar.com/_hcms/api/* -> apiUrl() (7 URLs).
//   3. Same-origin redirects -> root-relative paths.
//   4. localStorage -> storage.rawGet/rawSet/rawRemove.
//   5. @ts-nocheck for bare-minimum migration; proper typing is a follow-up.
// NOTE: document.querySelector('#page_3_payment_required_consent_widget')
//   reaches the HubSpot-generated module wrapper (parent of root) — these
//   selectors must stay document-scoped. Root-scoping is a planned fast-follow.
// NOTE: External hosts kept literal: aws.nautilussolar.com,
//   stripe.nautilussolar.com, portals.icheckgateway.com, api.na3.adobesign.com,
//   api.nautilussolar.com, api.ipify.org.
// NOTE: agreement documents live in agreements/ as versioned HTML assets and
//   are fetched per state through js/src/agreements/consent-agreements.

import { createTemplateGate, loadStateAgreements } from "../../agreements/consent-agreements"
import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { beginOperation, type LoadingOperationHandle } from "../../ui/loading-modal"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/consent/consent-pay.ts","init",[root,_config],["root","_config"]);
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/consent/consent-pay.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  // ─── Loading modal ─────────────────────────────────────────────────────────
  // Mechanical migration of the former fake-timer progress bar to the shared,
  // accessible loading modal (js/src/ui/loading-modal.ts). Kind "mutation" so a
  // genuine hang shows honest "may still be processing" copy with a Close escape,
  // never a fabricated 100%. The former 130s fill and the interval-leak are gone
  // by construction. A deferred audit will split this into read vs mutation
  // withLoader boundaries with abort/idempotency semantics.
  let loaderHandle: LoadingOperationHandle | null = null
  function openProgressBar(message = "We are saving your payment information") {
__ea_trace("modules/consent/consent-pay.ts","openProgressBar",[message],["message"]);
    loaderHandle = beginOperation({ kind: "mutation", message })
  }
  function closeProgressBar() {
__ea_trace("modules/consent/consent-pay.ts","closeProgressBar",[],[]);
    loaderHandle?.complete()
    loaderHandle = null
  }

  /* -------------- stripe js --------------- */
  let stripe, elements, paymentElement
  openProgressBar("Fetching Adobe agreement URL...")

  async function initializeStripe() {
__ea_trace("modules/consent/consent-pay.ts","initializeStripe",[],[]);
    try {
      stripe = Stripe(
        "pk_live_51JXAglFcE6xpXM1PYkO5cQWow0PbPrjzBS1QSoy7JZJg3SQjo7KwcKkfUeqsniU8HBUgsHregSMuTCVdjjx3FaRN003bqVtFDB",
      )
      const customer_email = storage.rawGet("userEmail")
      const customer_id = storage.rawGet("StripeCustomerId")
      const _amount = 50

      const res = await fetch("https://stripe.nautilussolar.com/stripeserver/setup/create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customer_email, customer_id }),
      })

      if (!res.ok) {
        throw new Error(`Setup intent creation failed with status ${res.status}`)
      }

      const data = await res.json()
      const clientSecret = data.clientSecret

      if (data.customerId) {
        storage.rawSet("StripeCustomerId", data.customerId)
      }

      elements = stripe.elements({
        clientSecret,
        wallets: {
          link: false,
        },
      })
      paymentElement = elements.create("payment")
      paymentElement.mount("#payment-element")

      paymentElement.on("change", (event) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[event],["event"]);
        if (event.value?.type) {
          const selectedMethod = event.value.type

          const methodMessage = document.getElementById("method-message")
          if (selectedMethod === "card") {
            methodMessage.textContent = ""
          } else if (selectedMethod === "us_bank_account") {
            methodMessage.textContent = ""
          } else {
            methodMessage.textContent = ""
          }
        }
      })
    } catch (error) {
      console.error("Error during Stripe initialization:", error)
      closeProgressBar()
      alert("There was an error initializing the payment form. Please try again later.")
    }
  }
  initializeStripe()
  var _stripe_amount = ""
  var _stripe_currency = ""
  var stripe_payment_id = ""
  var stripe_microdeposittype = ""
  var stripe_payment_status = ""
  var stripe_payment_method = ""
  var stripe_payment_method_id = ""
  var stripe_transaction_response = ""
  var stripe_payment_receipt_email = ""
  var _stripe_payment_verification_method = ""

  var billingType = ""
  var billingDetails = ""
  var billingResponse = ""
  var billingStatus = ""
  var StripeCCbrand = ""
  var StripeCCCountry = ""
  var StripeCCExpMonth = ""
  var StripeCCExpYear = ""
  var StripeCCLast4 = ""
  var StripeACHLast4 = ""
  var _StripeWallet = ""
  var StripeAccountHolder = ""
  var StripeAccountType = ""
  var StripeBankName = ""
  var _StripeFinancialConnectionAcc = ""
  var _StripeFingerPrint = ""
  var StripeRountingNumber = ""
  var StripePaymentMethod = ""
  var StripeCCUserAuth = "false"
  var StripeAchUserAuth = "false"
  var successMessage = ""
  var _paymentServiceProvider = ""
  var IsStripeFormDone = false
  var StripeCustomerId = ""

  ///this is the function for getting last month in expiry date........
  function getExpiryDateWithLastDay(expiryDate) {
__ea_trace("modules/consent/consent-pay.ts","getExpiryDateWithLastDay",[expiryDate],["expiryDate"]);
    const month = expiryDate.substring(0, 2)
    const year = `20${expiryDate.substring(2, 4)}` // Assuming the year is in the 2000s
    const lastDay = new Date(year, month, 0).getDate() // Get the last day of the month
    return `${month}/${lastDay.toString().padStart(2, "0")}/${year}`
  }
  function getExpiryDateWithISO(expiryDate) {
__ea_trace("modules/consent/consent-pay.ts","getExpiryDateWithISO",[expiryDate],["expiryDate"]);
    const month = expiryDate.substring(0, 2)
    const year = `20${expiryDate.substring(2, 4)}` // Assuming the year is in the 2000s
    const lastDay = new Date(year, month, 0).getDate() // Get the last day of the month
    const lastDayDate = new Date(Date.UTC(year, month - 1, lastDay))
    return lastDayDate.toISOString()
  }
  var tokenExpCalenderDate = ""
  var setupIntentResponse = ""
  async function getPaymentDetailBasedOnPaymentMethodId() {
__ea_trace("modules/consent/consent-pay.ts","getPaymentDetailBasedOnPaymentMethodId",[],[]);
    const res = await fetch("https://stripe.nautilussolar.com/stripeserver/payment/get-payment-method-by-id", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ payment_method_id: stripe_payment_method_id }),
    })

    const paymentMethodDetails = await res.json()
    billingResponse = JSON.stringify(paymentMethodDetails)
    billingDetails = JSON.stringify(paymentMethodDetails.billing_details)
    billingType = JSON.stringify(paymentMethodDetails.type)
    StripeCustomerId = paymentMethodDetails.customer

    if (paymentMethodDetails.type === "card") {
      StripeCCbrand = paymentMethodDetails.card.brand
      StripeCCCountry = paymentMethodDetails.card.country
      StripeCCExpMonth = paymentMethodDetails.card.exp_month
      StripeCCExpYear = paymentMethodDetails.card.exp_year
      StripeCCLast4 = paymentMethodDetails.card.last4
      _StripeWallet = paymentMethodDetails.card.wallet
      StripeCCUserAuth = "true"
      StripeAchUserAuth = "false"
      StripePaymentMethod = "Credit Card"
      successMessage = "Thank you, we have saved your preferred payment method."
      IsStripeFormDone = true

      StripeCCExpMonth = String(StripeCCExpMonth)
      StripeCCExpYear = String(StripeCCExpYear)

      if (StripeCCExpMonth.length === 1) {
        StripeCCExpMonth = 0 + StripeCCExpMonth
      }
      StripeCCExpYear = StripeCCExpYear.toString().slice(-2)
      tokenExpCalenderDate = getExpiryDateWithISO(StripeCCExpMonth + StripeCCExpYear)
    } else if (paymentMethodDetails.type === "us_bank_account") {
      StripeAccountHolder = paymentMethodDetails.us_bank_account.account_holder_type
      StripeAccountType = paymentMethodDetails.us_bank_account.account_type
      StripeBankName = paymentMethodDetails.us_bank_account.bank_name
      _StripeFinancialConnectionAcc = paymentMethodDetails.us_bank_account.financial_connections_account
      StripeACHLast4 = paymentMethodDetails.us_bank_account.last4
      _StripeFingerPrint = paymentMethodDetails.us_bank_account.fingerprint
      StripeRountingNumber = paymentMethodDetails.us_bank_account.routing_number
      StripeCCUserAuth = "false"
      StripeAchUserAuth = "true"
      StripePaymentMethod = "ACH"
      successMessage = "Thank you, we have saved your preferred payment method."
      IsStripeFormDone = true
      tokenExpCalenderDate = ""
      if (setupIntentResponse.next_action !== "null" && setupIntentResponse.next_action != null) {
        stripe_microdeposittype = setupIntentResponse.next_action.verify_with_microdeposits.microdeposit_type
      }
    } else {
      StripeCCbrand = ""
      StripeCCCountry = ""
      StripeCCExpMonth = ""
      StripeCCExpYear = ""
      StripeCCLast4 = ""
      StripeACHLast4 = ""
      _StripeWallet = ""
      StripeAccountHolder = ""
      StripeAccountType = ""
      StripeBankName = ""
      _StripeFinancialConnectionAcc = ""
      _StripeFingerPrint = ""
      StripeRountingNumber = ""
      StripeCCUserAuth = "false"
      StripeAchUserAuth = "false"
      StripePaymentMethod = ""
      successMessage = ""
      IsStripeFormDone = false
      tokenExpCalenderDate = ""
    }
    await updateStripeBillingDetail()
  }
  async function updateStripePaymentDetail() {
__ea_trace("modules/consent/consent-pay.ts","updateStripePaymentDetail",[],[]);
    var dealId = storage.rawGet("dealId")
    try {
      const data = {
        properties: {
          deal_id: dealId,
          stripe_payment_id: stripe_payment_id,
          stripe_payment_status: stripe_payment_status,
          stripe_payment_method: stripe_payment_method,
          stripe_payment_method_id: stripe_payment_method_id,
          stripe_transaction_response: stripe_transaction_response,
          stripe_payment_receipt_email: stripe_payment_receipt_email,
        },
      }
      const _response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  async function updateStripeBillingDetail() {
__ea_trace("modules/consent/consent-pay.ts","updateStripeBillingDetail",[],[]);
    if (StripeAccountHolder === "individual" && StripeAccountType === "checking") {
      StripeAccountType = "Personal Checking"
    } else if (StripeAccountHolder === "individual" && StripeAccountType === "savings") {
      StripeAccountType = "Personal Savings"
    }

    var dealId = storage.rawGet("dealId")
    try {
      const data = {
        properties: {
          deal_id: dealId,
          stripe_billing_type: billingType,
          stripe_billing_details: billingDetails,
          stripe_billing_response: billingResponse,
          stripe_cc_bnrand: StripeCCbrand,
          stripe_country: StripeCCCountry,
          cc_last_4: StripeCCLast4,
          cc_exp: `${StripeCCExpMonth}/${StripeCCExpYear}`,
          cc_exp_date: `${StripeCCExpMonth}/${StripeCCExpYear}`,
          token_expiration_date: tokenExpCalenderDate,
          cc_user_auth: StripeCCUserAuth,
          card_type: StripeCCbrand,
          wallet_token: stripe_payment_method_id,
          payment_vendor: "STRIPE",
          ach_name: StripeBankName,
          ach_rout_number: StripeRountingNumber,
          ach_account_number: StripeACHLast4,
          ach_account_type: StripeAccountType,
          ach_user_auth: StripeAchUserAuth,
          payment_method: StripePaymentMethod,
          billing_status: billingStatus,
          stripe_customer_id: StripeCustomerId,
          microdeposit_type: stripe_microdeposittype,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      if (response.ok) {
        document.querySelector("#page_3_payment_required_consent_widget #error-message").innerHTML = ""
        document.querySelector("#success-message").textContent = successMessage
        closeProgressBar()
      }
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }

  document.getElementById("submit").addEventListener("click", async (e) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[e],["e"]);
    e.preventDefault()
    openProgressBar("We are saving your payment information")
    document.querySelector("#success-message").textContent = ""
    const errorMessage = document.getElementById("error-message")

    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: "/thank-you",
      },
      redirect: "if_required", // prevents full redirect if not needed
    })

    if (error) {
      console.error(error)
      errorMessage.textContent = error.message
      closeProgressBar()
    } else {
      setupIntentResponse = setupIntent
      stripe_payment_id = setupIntent.id
      stripe_payment_status = setupIntent.status
      stripe_payment_method = JSON.stringify(setupIntent.payment_method_options)
      stripe_payment_method_id = setupIntent.payment_method
      stripe_transaction_response = JSON.stringify(setupIntent)
      billingStatus = setupIntent.status

      // ✅ You can now update details
      await updateStripePaymentDetail()
      await getPaymentDetailBasedOnPaymentMethodId()
    }
  })

  var responseFromAPI = ""
  /* ---------------------- Make dynamic icheck iframe src ------------------------- */
  function ICCiframe() {
__ea_trace("modules/consent/consent-pay.ts","ICCiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var companyName = storage.rawGet("CompanyName")
    var iframe = document.getElementById("iFrameCC")
    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"
    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    // Construct the dynamic src URL
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameCC.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      firstName +
      "&lastName=" +
      lastName +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    // Set the src attribute of the iframe

    iframe.src = dynamicSrc
  }
  function IBNiframe() {
__ea_trace("modules/consent/consent-pay.ts","IBNiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var iframe = document.getElementById("iFrameBN")
    var companyName = storage.rawGet("CompanyName")

    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"

    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameBA.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      encodeURIComponent(firstName) +
      "&lastName=" +
      encodeURIComponent(lastName) +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    iframe.src = dynamicSrc
  }
  ICCiframe()
  IBNiframe()
  /* ---------------------- Make dynamic icheck iframe src ------------------------- */

  /* loader function */
  function _paymentRequiredOpenLoader() {
__ea_trace("modules/consent/consent-pay.ts","_paymentRequiredOpenLoader",[],[]);
    var loader = document.getElementById("paymentRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PRloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }
  function _paymentRequiredCloseLoader() {
__ea_trace("modules/consent/consent-pay.ts","_paymentRequiredCloseLoader",[],[]);
    var loader = document.getElementById("paymentRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PRloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = false
    })
  }
  /* loader function */

  // --- Go back personal information button ---------------------------------
  document
    .querySelector("#page_3_payment_required_consent_widget #goback-personal-info")
    .addEventListener("click", () => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[],[]);
      var cp = storage.rawGet("credentialProvider")
      var lmiOption = storage.rawGet("lmi_option")
      if (cp === "NSE (Hansen)" && lmiOption === "Threshold Opt-Out") {
        window.location.href = "/my-usage" // redirect to normal hansen myusage page
      } else if (cp === "Bayou" && lmiOption === "Threshold Opt-Out") {
        window.location.href = "/myusage" // redirect to normal bayou myusage page
      } else if (cp === "NSE (Hansen)" && lmiOption === "null") {
        window.location.href = "/my-usage" // redirect to normal hansen myusage page
      } else if (cp === "Bayou" && lmiOption === "null") {
        window.location.href = "/myusage" // redirect to normal bayou myusage page
      } else if (cp === "Bayou") {
        window.location.href = "/my_usage" // redirect to lmi bayou myusage page
      } else if (cp === "NSE (Hansen)") {
        window.location.href = "/my-usage-lh" // redirect to lmi hansen myusage page
      } else {
        window.location.href = "/my-usage"
      }
    })
  // --- Go back personal information button ---------------------------------

  // If user is not logedIn then redirected them to login page -------------------------------------------------
  function getEmail() {
__ea_trace("modules/consent/consent-pay.ts","getEmail",[],[]);
    var storedEmail = storage.rawGet("userEmail")
    if (!storedEmail) {
      window.location.href = "/"
      return false
    }
  }
  getEmail()
  // If user is not logedIn then redirected them to login page -------------------------------------------------

  // Getting values from iframe --------------------------------------------------------------------------------
  var iFrameRoutingNo
  var iFrameaccountNumber
  var iFrameaccountName
  var iFrameaccountType
  var _iFrameBankamount
  var iFrameBanktoken
  var _iFrameBankoperation
  var iFrameBanksource
  var iFrameCreditCardNo
  var iFrameCreditaccountName
  var iFrameCreditcardExpDate
  var _IFrameCreditamount
  var IFrameCreditcardType
  var _IFrameCreditcardOperation
  var IFrameCreditcardToken
  var IFrameCreditcardsource
  var iFrameCreditcardExpFullDate
  var iFrameCreditcardExpFullDateIso
  var IsCreditCheckDone = false
  var IsValidateDisclosure = true
  var _IsValidateDataConsent = false
  var pageloaded = false
  var utilityId = ""
  var paymentResponse = ""

  var paymentprovider = storage.rawGet("FarmPayment")
  window.addEventListener("message", async (e) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[e],["e"]);
    // var jsonData = e.data;
    var jsonData
    if (typeof e.data === "string") {
      jsonData = JSON.parse(e.data)
    } else if (typeof e.data === "object" && e.data !== null) {
      jsonData = e.data
    } else {
      jsonData = e.data
    }

    if (paymentprovider === "stripe") {
      document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
      return
    } else {
      if (
        jsonData.error == null ||
        jsonData.error === "undefined" ||
        jsonData.error === undefined ||
        jsonData.action != null
      ) {
        if (jsonData.command != null || jsonData.command !== undefined) {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
          return
        } else if (jsonData.type != null || jsonData.type !== undefined) {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
          return
        } else {
          paymentResponse = JSON.stringify(jsonData)
        }

        if (jsonData.token == null || jsonData.token === "") {
          IsCreditCheckDone = false

          if (pageloaded === true) {
            document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
              "Please select at least one payment type."
          }
          return
        }

        if (jsonData.routingNumber == null || jsonData.routingNumber === "") {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
          IsCreditCheckDone = true
          // credit card
          document.getElementById("iBNMSG").innerHTML = ""
          document.getElementById("ICCMSG").innerHTML = "Thank you, your card information is approved."
          iFrameCreditCardNo = jsonData.cardNumber
          iFrameCreditaccountName = jsonData.accountName
          iFrameCreditcardExpDate = jsonData.cardExpDate
          IFrameCreditcardToken = jsonData.token
          IFrameCreditcardType = jsonData.cardType
          _IFrameCreditamount = jsonData.amount
          _IFrameCreditcardOperation = jsonData.operation
          IFrameCreditcardsource = jsonData.source
          IFrameCreditcardsource = IFrameCreditcardsource.toUpperCase()
          iFrameCreditcardExpFullDate = getExpiryDateWithLastDay(iFrameCreditcardExpDate)
          iFrameCreditcardExpFullDateIso = getExpiryDateWithISO(iFrameCreditcardExpDate)
        } else {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
          IsCreditCheckDone = true
          // bank
          document.getElementById("ICCMSG").innerHTML = ""
          document.getElementById("iBNMSG").innerHTML = "Thank you, your bank information is approved."
          iFrameRoutingNo = jsonData.routingNumber
          iFrameaccountNumber = jsonData.accountNumber
          iFrameaccountName = jsonData.accountName
          iFrameaccountType = jsonData.accountType
          _iFrameBankamount = jsonData.amount
          iFrameBanktoken = jsonData.token
          _iFrameBankoperation = jsonData.operation
          iFrameBanksource = jsonData.source
          iFrameBanksource = iFrameBanksource.toUpperCase()
        }
      } else {
        IsCreditCheckDone = false
        paymentResponse = JSON.stringify(jsonData)
        alert("Sorry the account details were not verified")
      }
    }
  })

  var _bankValidation_hasError = false
  var _creditValidation_hasError = false
  var storedDisplayElementList = JSON.parse(storage.rawGet("consentDisplayelementList"))
  var _storedRequireElementList = JSON.parse(storage.rawGet("consentrequireElementList"))
  var _noneitemCount = 0
  function ShowHide() {
__ea_trace("modules/consent/consent-pay.ts","ShowHide",[],[]);
    toggleElementVisibility("jnpiays-bank-credit", "PAYMENT OPTIONS DISPLAY")
    toggleElementVisibility("jnpiays-soft-card-check", "AUTHORIZATION CONSENT DISPLAY")
    toggleElementVisibility("jnpiays-credit", "CREDIT CHECK CONSENT DISPLAY")
  }
  function toggleElementVisibility(elementId, nameFromTable) {
__ea_trace("modules/consent/consent-pay.ts","toggleElementVisibility",[elementId,nameFromTable],["elementId","nameFromTable"]);
    const element = document.querySelector(`#page_3_payment_required_consent_widget #${elementId}`)
    if (storedDisplayElementList != null) {
      if (storedDisplayElementList.includes(nameFromTable)) {
        element.style.display = "block"
      } else {
        ++_noneitemCount

        element.style.display = "none"
      }
    }
  }
  ShowHide()
  document
    .querySelector("#page_3_payment_required_consent_widget #sa-download-a-copy-anchor")
    .addEventListener("click", savePdfSubAgreement)
  document
    .querySelector("#page_3_payment_required_consent_widget #dsc-download-a-copy-anchor")
    .addEventListener("click", savePdfDisclosure)
  document
    .querySelector("#page_3_payment_required_consent_widget #dsc-print-a-copy-anchor")
    .addEventListener("click", printDisclosure)
  document
    .querySelector("#page_3_payment_required_consent_widget #softCheck")
    .addEventListener("change", validateSoftCheckBox)
  document
    .querySelector("#page_3_payment_required_consent_widget #subscription_fullName")
    .addEventListener("input", validateSub_fullName)
  document
    .querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    .addEventListener("change", validateSub_checkbox)
  document
    .querySelector("#page_3_payment_required_consent_widget #subscription_checkbox_header")
    .addEventListener("change", validateSub_Firstcheckbox)
  document
    .querySelector("#page_3_payment_required_consent_widget #disclosure_fullName")
    .addEventListener("input", validateDis_fullName)
  document
    .querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")
    .addEventListener("change", validateDis_checkbox)
  document
    .querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox_header")
    .addEventListener("change", validateDis_Firstcheckbox)

  var showPayment = false
  function validateSoftCheckBox() {
__ea_trace("modules/consent/consent-pay.ts","validateSoftCheckBox",[],[]);
    if (!showPayment) return null

    var checkbox = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!checkbox.checked) {
      document.querySelector("#page_3_payment_required_consent_widget #softCheck_error_message").innerHTML =
        "Please check to agree to the Credit Check"
      return "error"
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #softCheck_error_message").innerHTML = ""
      return null
    }
  }
  function validateSub_fullName() {
__ea_trace("modules/consent/consent-pay.ts","validateSub_fullName",[],[]);
    if (!showSubscription) {
      return null
    }
    var value = document.querySelector("#page_3_payment_required_consent_widget #subscription_fullName").value.trim()
    if (value === "") {
      document.querySelector("#page_3_payment_required_consent_widget #subscription_fullName_error_message").innerHTML =
        "Please enter Full name."
      document.querySelector("#page_3_payment_required_consent_widget #subscription_thanktext").style.display = "none"
      return "error"
    } else if (!/^[a-zA-Z\s]+$/.test(value)) {
      document.querySelector("#page_3_payment_required_consent_widget #subscription_fullName_error_message").innerHTML =
        "Please enter a valid Full Name with only alphabetic characters."
      document.querySelector("#page_3_payment_required_consent_widget #subscription_thanktext").style.display = "none"
      return "error"
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #subscription_fullName_error_message").innerHTML =
        ""
      document.querySelector("#page_3_payment_required_consent_widget #subscription_thanktext").style.display = "block"
      return null
    }
    return null
  }
  function validateSub_checkbox() {
__ea_trace("modules/consent/consent-pay.ts","validateSub_checkbox",[],[]);
    if (!showSubscription) {
      return null
    }
    var checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    if (!checkbox.checked) {
      document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox_error_message").innerHTML =
        "Please enter your full name to agree to the Subscription Agreement."
      return "error"
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox_error_message").innerHTML =
        ""
      return null
    }
    return null
  }
  function validateSub_Firstcheckbox() {
__ea_trace("modules/consent/consent-pay.ts","validateSub_Firstcheckbox",[],[]);
    if (!showSubscription) {
      return null
    }
    var checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox_header")
    if (!checkbox.checked) {
      document.querySelector(
        "#page_3_payment_required_consent_widget #subscription_Firstcheckbox_error_message",
      ).innerHTML = "Please check the box to agree to the Subscription Agreement."
      return "error"
    } else {
      document.querySelector(
        "#page_3_payment_required_consent_widget #subscription_Firstcheckbox_error_message",
      ).innerHTML = ""
      return null
    }
    return null
  }
  function validateDis_fullName() {
__ea_trace("modules/consent/consent-pay.ts","validateDis_fullName",[],[]);
    if (!showDisclosure) {
      return null
    }
    var value = document.querySelector("#page_3_payment_required_consent_widget #disclosure_fullName").value.trim()
    if (value === "") {
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_fullName_error_message").innerHTML =
        "Please enter Full name."
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_thanktext").style.display = "none"
      return "error"
    } else if (!/^[a-zA-Z\s]+$/.test(value)) {
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_fullName_error_message").innerHTML =
        "Please enter a valid Full Name with only alphabetic characters."
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_thanktext").style.display = "none"
      return "error"
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_fullName_error_message").innerHTML =
        ""
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_thanktext").style.display = "block"
      return null
    }
  }
  function validateDis_checkbox() {
__ea_trace("modules/consent/consent-pay.ts","validateDis_checkbox",[],[]);
    if (!showDisclosure) return null
    var checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")
    if (!checkbox.checked) {
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox_error_message").innerHTML =
        "Please enter your full name to agree to the Disclosure Agreement."
      return "error"
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox_error_message").innerHTML =
        ""
      return null
    }
  }
  function validateDis_Firstcheckbox() {
__ea_trace("modules/consent/consent-pay.ts","validateDis_Firstcheckbox",[],[]);
    if (!showDisclosure) {
      return null
    }
    var checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox_header")
    if (!checkbox.checked) {
      document.querySelector(
        "#page_3_payment_required_consent_widget #disclosure_Firstcheckbox_error_message",
      ).innerHTML = "Please check the box to agree to the Disclosure Agreement."
      return "error"
    } else {
      document.querySelector(
        "#page_3_payment_required_consent_widget #disclosure_Firstcheckbox_error_message",
      ).innerHTML = ""
      return null
    }
  }
  function toggleDivVisibility() {
__ea_trace("modules/consent/consent-pay.ts","toggleDivVisibility",[],[]);
    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    var subscriptionAgreement = document.querySelector("#page_3_payment_required_consent_widget #subscriptionAgreement")
    var disclosure = document.querySelector("#page_3_payment_required_consent_widget #disclosure")
    if (softCheck.checked) {
      subscriptionAgreement.style.display = "block"
      disclosure.style.display = "block"
    } else {
      subscriptionAgreement.style.display = "none"
      disclosure.style.display = "none"
    }
  }

  async function validateForm() {
__ea_trace("modules/consent/consent-pay.ts","validateForm",[],[]);
    openProgressBar("We are saving your payment information")
    var paymentTypeElements = document.querySelectorAll("#page_3_payment_required_consent_widget .paymentType")
    var selectedPaymentType
    for (var i = 0; i < paymentTypeElements.length; i++) {
      if (paymentTypeElements[i].checked) {
        selectedPaymentType = paymentTypeElements[i].value
        break
      }
    }

    if (typeof selectedPaymentType === "undefined") {
      if (showPayment) {
        document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
          "Please select at least one payment type."
        closeProgressBar()
      }
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
      var checkbox = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
      if (!checkbox.checked) {
        if (showPayment) {
          document.querySelector("#page_3_payment_required_consent_widget #softCheck_error_message").innerHTML =
            "Please check to agree to the Credit Check"
          closeProgressBar()
          return alert("please grant soft check permission")
        }
      } else {
        document.querySelector("#page_3_payment_required_consent_widget #softCheck_error_message").innerHTML = ""
      }

      if (selectedPaymentType === "ACH") {
        if (IsCreditCheckDone === false) {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
            "Please add payment information."
          closeProgressBar()
          return
        } else {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
        }

        if (utilityId !== "XCEL-SF" && utilityId !== "NARRAG-SF") {
          var _bankValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
            ...(IsValidateDisclosure
              ? [validateDis_fullName(), validateDis_Firstcheckbox(), validateDis_checkbox()]
              : []),
          ]
        } else {
          var bankValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
          ]
        }
        var bankErrorMessage = bankValidationResult.filter((message) => message !== null)
        if (bankErrorMessage.length > 0) {
          closeProgressBar()
          alert("Please correct the error in Bank")
        } else {
          await uploadPdf()
          await addBankDataToDealRecord(selectedPaymentType)
        }
      } else if (selectedPaymentType === "Credit Card") {
        if (IsCreditCheckDone === false) {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
            "Please add payment information."
          closeProgressBar()
          return
        } else {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
        }

        if (utilityId !== "XCEL-SF" && utilityId !== "NARRAG-SF") {
          var _creditValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
            ...(IsValidateDisclosure
              ? [validateDis_fullName(), validateDis_Firstcheckbox(), validateDis_checkbox()]
              : []),
          ]
        } else {
          var creditValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
          ]
        }
        var creditErrorMessage = creditValidationResult.filter((message) => message !== null)
        if (creditErrorMessage.length > 0) {
          closeProgressBar()
          alert("Please authorize Nautilus Solar Energy LLC to perform a soft credit check.")
        } else {
          await uploadPdf()
          await addCreditCardDataToDealRecord(selectedPaymentType)
        }
      }
    }
  }
  async function validateStripeForm() {
__ea_trace("modules/consent/consent-pay.ts","validateStripeForm",[],[]);
    openProgressBar("We are saving your payment information")
    if (IsStripeFormDone === false) {
      if (showPayment) {
        document.querySelector("#page_3_payment_required_consent_widget #error-message").innerHTML =
          "Please select at least one payment type."
        closeProgressBar()
      } else {
        closeProgressBar()
      }
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #error-message").innerHTML = ""
      var checkbox = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
      if (!checkbox.checked) {
        if (showPayment) {
          document.querySelector("#page_3_payment_required_consent_widget #softCheck_error_message").innerHTML =
            "Please authorize Nautilus Solar Energy LLC to perform a soft credit check"
          closeProgressBar()
          return alert("please grant soft check permission")
        }
      } else {
        document.querySelector("#page_3_payment_required_consent_widget #softCheck_error_message").innerHTML = ""
      }

      if (StripePaymentMethod === "ACH") {
        if (utilityId !== "XCEL-SF" && utilityId !== "NARRAG-SF") {
          var _bankValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
            ...(IsValidateDisclosure
              ? [validateDis_fullName(), validateDis_Firstcheckbox(), validateDis_checkbox()]
              : []),
          ]
        } else {
          var bankValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
          ]
        }
        var bankErrorMessage = bankValidationResult.filter((message) => message !== null)
        if (bankErrorMessage.length > 0) {
          closeProgressBar()
          alert("Please correct the error in Bank")
        } else {
          await uploadPdf()
          await addStripeDataToDealRecord()
        }
      } else if (StripePaymentMethod === "Credit Card") {
        if (utilityId !== "XCEL-SF" && utilityId !== "NARRAG-SF") {
          var _creditValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
            ...(IsValidateDisclosure
              ? [validateDis_fullName(), validateDis_Firstcheckbox(), validateDis_checkbox()]
              : []),
          ]
        } else {
          var creditValidationResult = [
            validateSoftCheckBox(),
            validateSub_fullName(),
            validateSub_Firstcheckbox(),
            validateSub_checkbox(),
          ]
        }
        var creditErrorMessage = creditValidationResult.filter((message) => message !== null)

        if (creditErrorMessage.length > 0) {
          closeProgressBar()
          alert("Please correct the error in Credit")
        } else {
          await uploadPdf()
          await addStripeDataToDealRecord()
        }
      }
    }
  }
  function _unselectRadio() {
__ea_trace("modules/consent/consent-pay.ts","_unselectRadio",[],[]);
    document.querySelector("#page_3_payment_required_consent_widget #softRadio").checked = false
    document.querySelector("#page_3_payment_required_consent_widget #subscriptionAgreement").style.display = "none"
    document.querySelector("#page_3_payment_required_consent_widget #disclosure").style.display = "none"
  }
  function showContent(type) {
__ea_trace("modules/consent/consent-pay.ts","showContent",[type],["type"]);
    IsCreditCheckDone = false
    document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
    document.querySelector("#page_3_payment_required_consent_widget .jnpiays-bank-details").style.display = "none"
    document.querySelector("#page_3_payment_required_consent_widget .jnpiays-credit-details").style.display = "none"
    document.querySelector(`#page_3_payment_required_consent_widget .jnpiays-${type}-details`).style.display = "block"
  }
  async function delay(ms) {
__ea_trace("modules/consent/consent-pay.ts","delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  // update Deal Stage -------------------------------------------------------------------------------
  async function updateDealStage(value) {
__ea_trace("modules/consent/consent-pay.ts","updateDealStage",[value],["value"]);
    var _crd = storage.rawGet("credentialProvider")
    if (value === "1092432407" || value === "1100007032" || value === "127892571") {
    } else if (value === "984278689" || value === "127892570") {
      storage.rawSet("DealStage", "Submitted")
    } else if (storage.rawGet("credentialProvider") === "Bayou") {
      storage.rawSet("DealStage", "Submitted")
    }
    var dealId = storage.rawGet("dealId")
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value,
        },
      }
      const _response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }

  function _getCurrentTimestamp() {
__ea_trace("modules/consent/consent-pay.ts","_getCurrentTimestamp",[],[]);
    const now = new Date()

    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, "0")
    const day = String(now.getDate()).padStart(2, "0")

    const hours = String(now.getHours()).padStart(2, "0")
    const minutes = String(now.getMinutes()).padStart(2, "0")
    const seconds = String(now.getSeconds()).padStart(2, "0")

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }
  var ipAddress = ""
  // Example usage
  async function getPublicIP() {
__ea_trace("modules/consent/consent-pay.ts","getPublicIP",[],[]);
    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()
      ipAddress = data.ip
    } catch (error) {
      console.error("Error fetching public IP:", error)
    }
  }

  var pwd
  var upwd
  function dp(val) {
__ea_trace("modules/consent/consent-pay.ts","dp",[val],["val"]);
    pwd = crypt.decrypt(val)
  }
  function dup(val) {
__ea_trace("modules/consent/consent-pay.ts","dup",[val],["val"]);
    upwd = crypt.decrypt(val)
  }
  async function getLoginPass() {
__ea_trace("modules/consent/consent-pay.ts","getLoginPass",[],[]);
    openProgressBar("We are securing all of your finalized data.")
    var email = storage.rawGet("userEmail")
    var catchdata = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      const pr = dataa.userValue.properties.password
      dp(pr)
      if (dataa.message === "No User Found") {
      } else if (dataa.message === "User Found") {
        if (pwd !== "") {
          if (pr !== pwd) {
            await FPUpdatePassword(email, pwd)
          }
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function FPUpdatePassword(email, pwd) {
__ea_trace("modules/consent/consent-pay.ts","FPUpdatePassword",[email,pwd],["email","pwd"]);
    var catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          password: pwd,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function GetUtilityPass() {
__ea_trace("modules/consent/consent-pay.ts","GetUtilityPass",[],[]);
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "User Found") {
        var utps = dataa.userValue.properties.utility_password
        if (utps != null && utps !== "" && utps !== "null") {
          dup(utps)
        }
        if (upwd !== "" && upwd != null && upwd !== "null") {
          await updateUtilityPassword(upwd)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function updateUtilityPassword(pwd) {
__ea_trace("modules/consent/consent-pay.ts","updateUtilityPassword",[pwd],["pwd"]);
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          utility_password: pwd,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  /* --------------------------------------------------- dcrypted password on submit stage ------------------------------------------------------ */

  async function addBankDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-pay.ts","addBankDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    var subscription_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")
    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }
    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    if (iFrameaccountType === "PC") {
      iFrameaccountType = "Personal Checking"
    } else if (iFrameaccountType === "PS") {
      iFrameaccountType = "Personal Savings"
    } else if (iFrameaccountType === "BC") {
      iFrameaccountType = "Business Checking"
    } else if (iFrameaccountType === "BS") {
      iFrameaccountType = "Business Savings"
    } else if (iFrameaccountType === "GL") {
      iFrameaccountType = "General Ledger"
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    const timestamp = new Date().toISOString()
    try {
      if (utilityId !== "XCEL-SF") {
        var _data = {
          properties: {
            deal_id: dealId,
            ach_name: iFrameaccountName,
            ach_rout_number: iFrameRoutingNo,
            ach_account_number: iFrameaccountNumber,
            ach_account_type: iFrameaccountType,
            wallet_token: iFrameBanktoken,
            payment_vendor: iFrameBanksource,
            ach_user_auth: "true",
            payment_method: selectedPaymentType,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            disclosure_acknowledgement: disclosure_checkbox,
            disclosure_signature_typed: disclosure_fullName,
            saa_file_1_timestamp: timestamp,
            saa_file_2_timestamp: timestamp,
            saa_file_1_ip_address: ipAddress,
            saa_file_2_ip_address: ipAddress,
            lmi_saa_doc_file_1: SubAgreementUrl,
            lmi_saa_doc_file_2: DiscAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_doc_file_2_id: DiscAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            saa_document_sub_type_2: showDisclosure ? utilityDetails["76"][0].label : "",
            cc_name: "",
            cc_last_4: "",
            cc_exp: "",
            cc_exp_date: "",
            token_expiration_date: "",
            cc_user_auth: "",
            card_type: "",
            is_consent_doc_1_blank: isSubBlank,
            is_consent_doc_2_blank: isDisBlank,
            payment_response: paymentResponse,
          },
        }
      } else {
        var data = {
          properties: {
            deal_id: dealId,
            ach_name: iFrameaccountName,
            ach_rout_number: iFrameRoutingNo,
            ach_account_number: iFrameaccountNumber,
            ach_account_type: iFrameaccountType,
            wallet_token: iFrameBanktoken,
            payment_vendor: iFrameBanksource,
            ach_user_auth: "true",
            payment_method: selectedPaymentType,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_file_1_timestamp: timestamp,
            saa_file_1_ip_address: ipAddress,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            cc_name: "",
            cc_last_4: "",
            cc_exp: "",
            cc_exp_date: "",
            token_expiration_date: "",
            cc_user_auth: "",
            card_type: "",
            is_consent_doc_1_blank: isSubBlank,
            payment_response: paymentResponse,
          },
        }
      }
      if (isSubBlank != null) {
        data.properties.is_consent_doc_1_blank = isSubBlank
      }

      if (isDisBlank != null) {
        data.properties.is_consent_doc_2_blank = isDisBlank
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        var value = storage.rawGet("skipUsage")
        if (value === "Yes") {
          updateDealStage("127892571")
          storage.rawSet("typ", "UtAsTaNc")
          storage.rawSet("typ_usage_btn", "Show")
          storage.rawSet("typ_stripe_btn", "Hide")
          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        } else if (value === "No") {
          updateDealStage("127892570")
          storage.rawSet("typ", "lMiAsTaNc")
          await getLoginPass()
          await GetUtilityPass()
          storage.rawSet("typ_usage_btn", "Hide")
          storage.rawSet("typ_stripe_btn", "Hide")

          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        } else {
          updateDealStage("127892570")
          storage.rawSet("typ", "lMiAsTaNc")
          await getLoginPass()
          await GetUtilityPass()
          storage.rawSet("typ_usage_btn", "Hide")
          storage.rawSet("typ_stripe_btn", "Hide")

          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        }
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  async function addCreditCardDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-pay.ts","addCreditCardDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    var subscription_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")

    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }

    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    var timestamp = new Date().toISOString()

    try {
      if (utilityId !== "XCEL-SF") {
        var _data = {
          properties: {
            deal_id: dealId,
            payment_method: selectedPaymentType,
            cc_name: iFrameCreditaccountName,
            cc_last_4: iFrameCreditCardNo,
            cc_exp: iFrameCreditcardExpDate,
            cc_exp_date: iFrameCreditcardExpFullDate,
            token_expiration_date: iFrameCreditcardExpFullDateIso,
            cc_user_auth: "true",
            card_type: IFrameCreditcardType,
            wallet_token: IFrameCreditcardToken,
            payment_vendor: IFrameCreditcardsource,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            disclosure_acknowledgement: disclosure_checkbox,
            disclosure_signature_typed: disclosure_fullName,
            saa_file_1_timestamp: timestamp,
            saa_file_2_timestamp: timestamp,
            saa_file_1_ip_address: ipAddress,
            saa_file_2_ip_address: ipAddress,
            lmi_saa_doc_file_1: SubAgreementUrl,
            lmi_saa_doc_file_2: DiscAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_doc_file_2_id: DiscAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            saa_document_sub_type_2: showDisclosure ? utilityDetails["76"][0].label : "",
            ach_name: "",
            ach_rout_number: "",
            ach_account_number: "",
            ach_account_type: "",
            ach_user_auth: "",
            is_consent_doc_1_blank: isSubBlank,
            is_consent_doc_2_blank: isDisBlank,
            payment_response: paymentResponse,
          },
        }
      } else {
        var data = {
          properties: {
            deal_id: dealId,
            payment_method: selectedPaymentType,
            cc_name: iFrameCreditaccountName,
            cc_last_4: iFrameCreditCardNo,
            cc_exp: iFrameCreditcardExpDate,
            cc_exp_date: iFrameCreditcardExpFullDate,
            token_expiration_date: iFrameCreditcardExpFullDateIso,
            cc_user_auth: "true",
            card_type: IFrameCreditcardType,
            wallet_token: IFrameCreditcardToken,
            payment_vendor: IFrameCreditcardsource,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_file_1_timestamp: timestamp,
            saa_file_1_ip_address: ipAddress,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            ach_name: "",
            ach_rout_number: "",
            ach_account_number: "",
            ach_account_type: "",
            ach_user_auth: "",
            is_consent_doc_1_blank: isSubBlank,
            payment_response: paymentResponse,
          },
        }
      }
      if (isSubBlank !== null) {
        data.properties.is_consent_doc_1_blank = isSubBlank
      }

      if (isDisBlank !== null) {
        data.properties.is_consent_doc_2_blank = isDisBlank
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        var value = storage.rawGet("skipUsage")
        if (value === "Yes") {
          updateDealStage("127892571")
          storage.rawSet("typ", "UtAsTaNc")
          storage.rawSet("typ_usage_btn", "Show")
          storage.rawSet("typ_stripe_btn", "Hide")

          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        } else if (value === "No") {
          updateDealStage("127892570")
          storage.rawSet("typ", "lMiAsTaNc")
          await getLoginPass()
          await GetUtilityPass()
          storage.rawSet("typ_usage_btn", "Hide")
          storage.rawSet("typ_stripe_btn", "Hide")

          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        } else {
          updateDealStage("127892570")
          storage.rawSet("typ", "lMiAsTaNc")
          await getLoginPass()
          await GetUtilityPass()
          storage.rawSet("typ_usage_btn", "Hide")
          storage.rawSet("typ_stripe_btn", "Hide")

          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        }
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  async function addStripeDataToDealRecord() {
__ea_trace("modules/consent/consent-pay.ts","addStripeDataToDealRecord",[],[]);
    var subscription_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")
    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }
    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    const timestamp = new Date().toISOString()
    try {
      if (utilityId !== "XCEL-SF") {
        var _data = {
          properties: {
            deal_id: dealId,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            disclosure_acknowledgement: disclosure_checkbox,
            disclosure_signature_typed: disclosure_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            lmi_saa_doc_file_2: DiscAgreementUrl,
            saa_file_1_timestamp: timestamp,
            saa_file_2_timestamp: timestamp,
            saa_file_1_ip_address: ipAddress,
            saa_file_2_ip_address: ipAddress,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            saa_document_sub_type_2: showDisclosure ? utilityDetails["76"][0].label : "",
            saa_document_sub_type_3: showdataConsent ? utilityDetails["86"][0].label : "",
            is_consent_doc_1_blank: isSubBlank,
            is_consent_doc_2_blank: isDisBlank,
          },
        }
      } else {
        var data = {
          properties: {
            deal_id: dealId,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            saa_file_1_timestamp: timestamp,
            saa_file_1_ip_address: ipAddress,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            is_consent_doc_1_blank: isSubBlank,
          },
        }
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        var value = storage.rawGet("skipUsage")
        if (value === "Yes") {
          storage.rawSet("typ", "UtAsTaNc")
          storage.rawSet("typ_usage_btn", "Show")
          if (billingStatus === "requires_action") {
            storage.rawSet("typ_stripe_btn", "Show")
            updateDealStage("1142098958")
          } else {
            updateDealStage("127892571")
            storage.rawSet("typ_stripe_btn", "Hide")
          }
          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        } else if (value === "No") {
          if (billingStatus === "requires_action") {
            storage.rawSet("typ", "UtAsTaNc")
            storage.rawSet("typ_stripe_btn", "Show")
            storage.rawSet("typ_usage_btn", "Hide")
            updateDealStage("1142098957")
          } else {
            storage.rawSet("typ", "lMiAsTaNc")
            storage.rawSet("typ_stripe_btn", "Hide")
            storage.rawSet("typ_usage_btn", "Hide")
            updateDealStage("127892570")
          }
          await getLoginPass()
          await GetUtilityPass()

          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        } else {
          if (billingStatus === "requires_action") {
            storage.rawSet("typ", "UtAsTaNc")
            storage.rawSet("typ_stripe_btn", "Show")
            storage.rawSet("typ_usage_btn", "Hide")
            updateDealStage("1142098957")
          } else {
            storage.rawSet("typ", "lMiAsTaNc")
            storage.rawSet("typ_stripe_btn", "Hide")
            storage.rawSet("typ_usage_btn", "Hide")
            updateDealStage("127892570")
          }
          await getLoginPass()
          await GetUtilityPass()

          await delay(10000)
          closeProgressBar()
          window.location.href = "/thank-you"
        }
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }

  // save my place to deal record --------------------------------------------------------------------
  async function saveBankDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-pay.ts","saveBankDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    var subscription_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")

    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }

    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    if (iFrameaccountType === "PC") {
      iFrameaccountType = "Personal Checking"
    } else if (iFrameaccountType === "PS") {
      iFrameaccountType = "Personal Savings"
    } else if (iFrameaccountType === "BC") {
      iFrameaccountType = "Business Checking"
    } else if (iFrameaccountType === "BS") {
      iFrameaccountType = "Business Savings"
    } else if (iFrameaccountType === "GL") {
      iFrameaccountType = "General Ledger"
    }
    //         var email = storage.rawGet("userEmail");
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      if (utilityId !== "XCEL-SF") {
        var _data = {
          properties: {
            deal_id: dealId,
            ach_name: iFrameaccountName,
            ach_rout_number: iFrameRoutingNo,
            ach_account_number: iFrameaccountNumber,
            ach_account_type: iFrameaccountType,
            wallet_token: iFrameBanktoken,
            payment_vendor: iFrameBanksource,
            ach_user_auth: "true",
            payment_method: selectedPaymentType,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            disclosure_acknowledgement: disclosure_checkbox,
            disclosure_signature_typed: disclosure_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            lmi_saa_doc_file_2: DiscAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_doc_file_2_id: DiscAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            saa_document_sub_type_2: showDisclosure ? utilityDetails["76"][0].label : "",
            cc_name: "",
            cc_last_4: "",
            cc_exp: "",
            cc_exp_date: "",
            token_expiration_date: "",
            cc_user_auth: "",
            card_type: "",
          },
        }
      } else {
        var data = {
          properties: {
            deal_id: dealId,
            ach_name: iFrameaccountName,
            ach_rout_number: iFrameRoutingNo,
            ach_account_number: iFrameaccountNumber,
            ach_account_type: iFrameaccountType,
            wallet_token: iFrameBanktoken,
            payment_vendor: iFrameBanksource,
            ach_user_auth: "true",
            payment_method: selectedPaymentType,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            cc_name: "",
            cc_last_4: "",
            cc_exp: "",
            cc_exp_date: "",
            token_expiration_date: "",
            cc_user_auth: "",
            card_type: "",
          },
        }
      }
      if (isSubBlank !== null) {
        data.properties.is_consent_doc_1_blank = isSubBlank
      }

      if (isDisBlank !== null) {
        data.properties.is_consent_doc_2_blank = isDisBlank
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function saveCreditCardDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-pay.ts","saveCreditCardDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    var subscription_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")

    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }
    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      if (utilityId !== "XCEL-SF") {
        var _data = {
          properties: {
            deal_id: dealId,
            payment_method: selectedPaymentType,
            cc_name: iFrameCreditaccountName,
            cc_last_4: iFrameCreditCardNo,
            cc_exp: iFrameCreditcardExpDate,
            cc_user_auth: "true",
            card_type: IFrameCreditcardType,
            wallet_token: IFrameCreditcardToken,
            payment_vendor: IFrameCreditcardsource,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            disclosure_acknowledgement: disclosure_checkbox,
            disclosure_signature_typed: disclosure_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            lmi_saa_doc_file_2: DiscAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_doc_file_2_id: DiscAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            saa_document_sub_type_2: showDisclosure ? utilityDetails["76"][0].label : "",
            ach_name: "",
            ach_rout_number: "",
            ach_account_number: "",
            ach_account_type: "",
            ach_user_auth: "",
          },
        }
      } else {
        var data = {
          properties: {
            deal_id: dealId,
            payment_method: selectedPaymentType,
            cc_name: iFrameCreditaccountName,
            cc_last_4: iFrameCreditCardNo,
            cc_exp: iFrameCreditcardExpDate,
            cc_user_auth: "true",
            card_type: IFrameCreditcardType,
            wallet_token: IFrameCreditcardToken,
            payment_vendor: IFrameCreditcardsource,
            credit_check_agreement: softCheck,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            ach_name: "",
            ach_rout_number: "",
            ach_account_number: "",
            ach_account_type: "",
            ach_user_auth: "",
          },
        }
      }
      if (isSubBlank !== null) {
        data.properties.is_consent_doc_1_blank = isSubBlank
      }

      if (isDisBlank !== null) {
        data.properties.is_consent_doc_2_blank = isDisBlank
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function savediscluserandagreementdata() {
__ea_trace("modules/consent/consent-pay.ts","savediscluserandagreementdata",[],[]);
    var subscription_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector("#page_3_payment_required_consent_widget #subscription_checkbox")
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_payment_required_consent_widget #disclosure_checkbox")

    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }

    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }

    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      if (utilityId !== "XCEL-SF") {
        var _data = {
          properties: {
            deal_id: dealId,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            disclosure_acknowledgement: disclosure_checkbox,
            disclosure_signature_typed: disclosure_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            lmi_saa_doc_file_2: DiscAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_doc_file_2_id: DiscAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
            saa_document_sub_type_2: showDisclosure ? utilityDetails["76"][0].label : "",
          },
        }
      } else {
        var data = {
          properties: {
            deal_id: dealId,
            subscription_acknowledgement: subscription_checkbox,
            subscription_signature_typed: subscription_fullName,
            lmi_saa_doc_file_1: SubAgreementUrl,
            saa_doc_file_1_id: SubAgreementId,
            saa_document_sub_type_1: showSubscription ? utilityDetails["75"][0].label : "",
          },
        }
      }
      if (isSubBlank !== null) {
        data.properties.is_consent_doc_1_blank = isSubBlank
      }

      if (isDisBlank !== null) {
        data.properties.is_consent_doc_2_blank = isDisBlank
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  function saveForm() {
__ea_trace("modules/consent/consent-pay.ts","saveForm",[],[]);
    var paymentTypeElements = document.querySelectorAll("#page_3_payment_required_consent_widget .paymentType")
    var selectedPaymentType
    for (var i = 0; i < paymentTypeElements.length; i++) {
      if (paymentTypeElements[i].checked) {
        selectedPaymentType = paymentTypeElements[i].value
        break
      }
    }
    document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
    var _checkbox = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (selectedPaymentType === "ACH") {
      saveBankDataToDealRecord(selectedPaymentType)
    } else if (selectedPaymentType === "Credit Card") {
      saveCreditCardDataToDealRecord(selectedPaymentType)
    } else {
      savediscluserandagreementdata()
    }
  }
  document.querySelector("#page_3_payment_required_consent_widget #save-remind").addEventListener("click", saveForm)
  // save my place to deal record --------------------------------------------------------------------

  var utilityAccountNumber = ""
  var _utilityAccountNumber2 = ""
  // ------------- Get saved data -------------------------------
  async function GetDataFromDealRecord() {
__ea_trace("modules/consent/consent-pay.ts","GetDataFromDealRecord",[],[]);
    paymentprovider = storage.rawGet("FarmPayment")
    utilityId = JSON.parse(storage.rawGet("UtilitySessionDetails"))["1"]
    if (paymentprovider === "icheck") {
      document
        .querySelector("#page_3_payment_required_consent_widget #get-utility-info")
        .addEventListener("click", validateForm)
    } else if (
      paymentprovider === "stripe" ||
      paymentprovider === "" ||
      paymentprovider == null ||
      paymentprovider === undefined
    ) {
      document
        .querySelector("#page_3_payment_required_consent_widget #get-utility-info")
        .addEventListener("click", validateStripeForm)
    } else {
      document
        .querySelector("#page_3_payment_required_consent_widget #get-utility-info")
        .addEventListener("click", validateStripeForm)
    }

    if (paymentprovider === "icheck") {
      document.querySelector("#jnpiays-bank-credit").style.display = "block"
      document.querySelector("#stripeBankCreditMain").style.display = "none"
    } else if (
      paymentprovider === "stripe" ||
      paymentprovider === "" ||
      paymentprovider == null ||
      paymentprovider === undefined
    ) {
      document.querySelector("#jnpiays-bank-credit").style.display = "none"
      document.querySelector("#stripeBankCreditMain").style.display = "block"
    } else {
      document.querySelector("#jnpiays-bank-credit").style.display = "none"
      document.querySelector("#stripeBankCreditMain").style.display = "block"
    }

    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      await getPublicIP()
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "User Found") {
        var paymentMethod = dataa.userValue.properties.payment_method
        var creditCheckAgreement = dataa.userValue.properties.credit_check_agreement
        var subscriptionAcknowledgement = dataa.userValue.properties.subscription_acknowledgement
        var subscriptionSignatureTyped = dataa.userValue.properties.subscription_signature_typed
        var disclosureAcknowledgement = dataa.userValue.properties.disclosure_acknowledgement
        var disclosureSignatureTyped = dataa.userValue.properties.disclosure_signature_typed
        var lmiOption = dataa.userValue.properties.lmi_option
        storage.rawSet("lmi_option", lmiOption)
        var uan_1_value = dataa.userValue.properties.uan_1_value
        var uan_2_value = dataa.userValue.properties.uan_2_value
        utilityAccountNumber = uan_1_value
        _utilityAccountNumber2 = uan_2_value
        var ACHType = document.querySelector("#page_3_payment_required_consent_widget #ACH")
        var CreditCardType = document.querySelector("#page_3_payment_required_consent_widget #CreditCard")
        var softCheckType = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
        var subscriptionCheckboxType = document.querySelector(
          "#page_3_payment_required_consent_widget #subscription_checkbox",
        )
        var subscriptionFullNameType = document.querySelector(
          "#page_3_payment_required_consent_widget #subscription_fullName",
        )
        var disclosureCheckboxType = document.querySelector(
          "#page_3_payment_required_consent_widget #disclosure_checkbox",
        )
        var disclosureFullNameType = document.querySelector(
          "#page_3_payment_required_consent_widget #disclosure_fullName",
        )

        if (paymentMethod === "ACH") {
          ACHType.checked = true
        } else if (paymentMethod === "Credit Card") {
          CreditCardType.checked = true
        }
        if (creditCheckAgreement === "true") {
          softCheckType.checked = true
        }
        if (subscriptionAcknowledgement === "true") {
          subscriptionCheckboxType.checked = true
        }
        if (disclosureAcknowledgement === "true") {
          disclosureCheckboxType.checked = true
        }
        if (subscriptionSignatureTyped) {
          subscriptionFullNameType.value = subscriptionSignatureTyped
        }
        if (disclosureSignatureTyped) {
          disclosureFullNameType.value = disclosureSignatureTyped
        }

        if (utilityId === "XCEL-CO-SF") {
          document.querySelector(".jnpiays-main").style.display = "none"
          document.querySelector("#disclosure").style.display = "block"
          document.querySelector(".dataConsentAgreement").style.display = "block"
          document.querySelector("#firstStepButton").style.display = "block"
          var dataConsent_adobe_agreement_id = dataa.userValue.properties.dataconsent_adobe_agreement_id
          var dcDocStatusOnLoad = dataa.userValue.properties.data_consent_document_status
          if (dcDocStatusOnLoad !== "SIGNED") {
            if (
              dataConsent_adobe_agreement_id == null ||
              dataConsent_adobe_agreement_id === "null" ||
              dataConsent_adobe_agreement_id === ""
            ) {
              await createDataConsentAdobeAgreement()
            } else {
              storage.rawSet("DataConsentagreementId", dataConsent_adobe_agreement_id)
              await sendDataConsentAgreementIdToGetStatus(dataConsent_adobe_agreement_id)
            }
          } else {
            document.querySelector(".jnpiays-main").style.display = "block"
            document.querySelector(".dataConsentAgreement").style.display = "none"
            document.querySelector("#firstStepButton").style.display = "none"
            closeProgressBar()
          }
        } else if (utilityId === "XCEL-SF") {
          document.querySelector(".jnpiays-main").style.display = "none"
          document.querySelector("#disclosure").style.display = "none"
          document.querySelector(".mnAgreement").style.display = "block"
          document.querySelector("#mnfirstStepButton").style.display = "block"
          var mn_adobe_agreement_id = dataa.userValue.properties.minnesota_adobe_agreement_id
          var mnDocStatusOnLoad = dataa.userValue.properties.minnesota_document_status
          if (mnDocStatusOnLoad !== "SIGNED") {
            if (mn_adobe_agreement_id == null || mn_adobe_agreement_id === "null" || mn_adobe_agreement_id === "") {
              await createMinnesotaAdobeAgreement()
            } else {
              storage.rawSet("MinnesotaagreementId", mn_adobe_agreement_id)
              await sendMinnesotaAgreementIdToGetStatus(mn_adobe_agreement_id)
            }
          } else {
            document.querySelector(".jnpiays-main").style.display = "block"
            document.querySelector(".mnAgreement").style.display = "none"
            document.querySelector("#mnfirstStepButton").style.display = "none"
            closeProgressBar()
          }
        } else if (utilityId === "NARRAG-SF") {
          document.querySelector(".jnpiays-main").style.display = "block"
          document.querySelector("#disclosure").style.display = "none"
          document.querySelector(".dataConsentAgreement").style.display = "none"
          document.querySelector("#firstStepButton").style.display = "none"
          document.querySelector(".mnAgreement").style.display = "none"
          document.querySelector("#mnfirstStepButton").style.display = "none"
          closeProgressBar()
        } else {
          document.querySelector(".jnpiays-main").style.display = "block"
          document.querySelector("#disclosure").style.display = "block"
          document.querySelector(".dataConsentAgreement").style.display = "none"
          document.querySelector("#firstStepButton").style.display = "none"
          document.querySelector(".mnAgreement").style.display = "none"
          document.querySelector("#mnfirstStepButton").style.display = "none"
          closeProgressBar()
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  // ------------- Get saved data -------------------------------

  // get Subscription and Disclosure from session config table ----------------------------------------------------
  async function GetSubscriptionAndDisclosureFromSessionConfigTable() {
__ea_trace("modules/consent/consent-pay.ts","GetSubscriptionAndDisclosureFromSessionConfigTable",[],[]);
    await GetDataFromDealRecord()
    var u_id = storage.rawGet("utility_id")
    try {
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id=${u_id}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      var rows = data.objects
      if (rows.length >= 1) {
        var _disclosure = rows[0].values[65]
        var _subscriptionAgreement = rows[0].values[66]
      }
    } catch (error) {
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  GetSubscriptionAndDisclosureFromSessionConfigTable()
  // get Subscription and Disclosure from session config table ----------------------------------------------------

  // pdf and print ---------------------------------------------------------------------
  var loggedName = storage.rawGet("LoggedName")
  var loggedAddress = storage.rawGet("Address")
  var streetAddress = storage.rawGet("Street Address") ?? ""
  var loggedCity = storage.rawGet("city") ?? ""
  var loggedEmail = storage.rawGet("userEmail")
  var loggedState = storage.rawGet("stateForLMIConfig")
  var loggedZip = storage.rawGet("zip_code")
  var loggedHomePhone = storage.rawGet("HomePhone")
  var loggedCellPhone = storage.rawGet("CellPhone")
  var loggedCounty = storage.rawGet("county") ?? ""

  document.querySelector("#page_3_payment_required_consent_widget #SubAgree-para").innerHTML =
    `I, <strong>${loggedName}</strong>, acknowledge that typing my name below constitutes my electronic signature.  I understand this carries the same legal enforceability as my hand-written signature.`
  document.querySelector("#page_3_payment_required_consent_widget #disclosure-para").innerHTML =
    `I, <strong>${loggedName}</strong>, acknowledge that typing my name below constitutes my electronic signature.  I understand this carries the same legal enforceability as my hand-written signature.`
  var Farm_LLC = storage.rawGet("FarmName")
  if (Farm_LLC === undefined || Farm_LLC === "undefined") {
    Farm_LLC = ""
  }
  var Farm_Project_Description = storage.rawGet("FarmProjectDescription")
  if (Farm_Project_Description === undefined || Farm_Project_Description === "undefined") {
    Farm_Project_Description = ""
  }
  var Farm_Phone_Number = storage.rawGet("FarmPhoneNumber")
  if (Farm_Phone_Number === undefined || Farm_Phone_Number === "undefined") {
    Farm_Phone_Number = ""
  }
  var Farm_LLC_Address1 = storage.rawGet("FarmStreetAddress1")
  if (Farm_LLC_Address1 === undefined || Farm_LLC_Address1 === "undefined") {
    Farm_LLC_Address1 = ""
  }
  var FarmLLC = storage.rawGet("FarmLlc")
  if (FarmLLC === undefined || FarmLLC === "undefined") {
    FarmLLC = ""
  }
  var FarmLlcAddress1 = storage.rawGet("FarmLlcAddress1")
  if (FarmLlcAddress1 === undefined || FarmLlcAddress1 === "undefined") {
    FarmLlcAddress1 = ""
  }
  var FarmLlcAddress2 = storage.rawGet("FarmLlcAddress2")
  if (FarmLlcAddress2 === undefined || FarmLlcAddress2 === "undefined") {
    FarmLlcAddress2 = ""
  }
  var FarmLlcCity = storage.rawGet("FarmLlcCity")
  if (FarmLlcCity === undefined || FarmLlcCity === "undefined") {
    FarmLlcCity = ""
  }
  var FarmLlcZip = storage.rawGet("FarmLlcZip")
  if (FarmLlcZip === undefined || FarmLlcZip === "undefined") {
    FarmLlcZip = ""
  }
  var FarmStateAbbreviation = storage.rawGet("FarmStateAbbreviation")
  if (FarmStateAbbreviation === undefined || FarmStateAbbreviation === "undefined") {
    FarmStateAbbreviation = ""
  }

  var Farm_LLC_Address2 = ""
  var Farm_LLC_City = ""
  var Farm_LLC_State = ""
  var Farm_LLC_Zip = ""
  var Farm_LLC_Email = ""
  var Farm_LLC_Id = ""
  var Farm_Display_Name = ""

  if (
    storage.rawGet("HomePhone") === undefined ||
    storage.rawGet("HomePhone") === "undefined" ||
    storage.rawGet("HomePhone") === "null" ||
    storage.rawGet("HomePhone") == null ||
    storage.rawGet("HomePhone") === ""
  ) {
    loggedHomePhone = null
  } else {
    loggedHomePhone = storage.rawGet("HomePhone")
  }
  if (
    storage.rawGet("CellPhone") === undefined ||
    storage.rawGet("CellPhone") === "undefined" ||
    storage.rawGet("CellPhone") === "null" ||
    storage.rawGet("CellPhone") == null ||
    storage.rawGet("CellPhone") === ""
  ) {
    loggedCellPhone = ""
  } else {
    loggedCellPhone = storage.rawGet("CellPhone")
  }

  if (storage.rawGet("FarmStreetAddress2") === undefined || storage.rawGet("FarmStreetAddress2") === "undefined") {
    Farm_LLC_Address2 = ""
  } else {
    Farm_LLC_Address2 = storage.rawGet("FarmStreetAddress2")
  }
  if (storage.rawGet("FarmCity") === undefined || storage.rawGet("FarmCity") === "undefined") {
    Farm_LLC_City = ""
  } else {
    Farm_LLC_City = storage.rawGet("FarmCity")
  }
  if (storage.rawGet("Farm_LLC_State") === undefined || storage.rawGet("Farm_LLC_State") === "undefined") {
    Farm_LLC_State = ""
  } else {
    Farm_LLC_State = storage.rawGet("Farm_LLC_State")
  }
  if (storage.rawGet("zip_code") === undefined || storage.rawGet("zip_code") === "undefined") {
    Farm_LLC_Zip = ""
  } else {
    Farm_LLC_Zip = storage.rawGet("zip_code")
  }
  if (storage.rawGet("FarmEmail") === undefined || storage.rawGet("FarmEmail") === "undefined") {
    Farm_LLC_Email = ""
  } else {
    Farm_LLC_Email = storage.rawGet("FarmEmail")
  }
  if (storage.rawGet("FarmID") === undefined || storage.rawGet("FarmID") === "undefined") {
    Farm_LLC_Id = ""
  } else {
    Farm_LLC_Id = storage.rawGet("FarmID")
  }
  if (storage.rawGet("FarmDisplayName") === undefined || storage.rawGet("FarmDisplayName") === "undefined") {
    Farm_Display_Name = ""
  } else {
    Farm_Display_Name = storage.rawGet("FarmDisplayName")
  }

  var subscriptionSignedName = storage.rawGet("LoggedName")
  var SessionLogo = JSON.parse(storage.rawGet("UtilitySessionDetails"))["17"].url
  var _logowidth = JSON.parse(storage.rawGet("UtilitySessionDetails"))["17"].width
  var _logoheight = JSON.parse(storage.rawGet("UtilitySessionDetails"))["17"].height
  var today = new Date()

  // Get the day, month, and year
  var day = String(today.getDate()).padStart(2, "0")
  var month = String(today.getMonth() + 1).padStart(2, "0") // January is 0!
  var year = today.getFullYear()
  var userTitle = ""
  var _utilityDisplayName = JSON.parse(storage.rawGet("UtilitySessionDetails"))["5"]
  var monthName = new Intl.DateTimeFormat("en-US", { month: "long" }).format(today)
  var formattedDate3 = `${monthName} ${day} ${year}`
  var formattedDate = `${day} ${month} ${year}`
  var formattedDate2 = `${month}/${day}/${year}`

  ///values for co disclosure
  var retailCustomerNumber = storage.rawGet("UanNumber") ?? ""
  var _subOrgName = "Company name"
  //end of value for disclosure
  var utilityDetails = storage.rawGet("UtilitySessionDetails")
  var showSubscription = false
  var showDisclosure = false
  var showdataConsent = false
  var stageName
  var standardDiscount = storage.rawGet("FarmOpenDiscount") ?? ""
  var lmiDiscount = storage.rawGet("FarmLMIDiscount") ?? ""

  var saa1timestamprh = new Date()

  var yearrh = saa1timestamprh.getFullYear()
  var monthrh = String(saa1timestamprh.getMonth() + 1).padStart(2, "0")
  var dayrh = String(saa1timestamprh.getDate()).padStart(2, "0")

  var hoursrh = String(saa1timestamprh.getHours()).padStart(2, "0")
  var minutesrh = String(saa1timestamprh.getMinutes()).padStart(2, "0")
  var secondsrh = String(saa1timestamprh.getSeconds()).padStart(2, "0")

  var formattedDateStamprh = `${yearrh}-${monthrh}-${dayrh} ${hoursrh}:${minutesrh}:${secondsrh}`
  var formattedDaterh = `${yearrh}-${monthrh}-${dayrh}`
  if (utilityDetails) {
    utilityDetails = JSON.parse(utilityDetails)
    stageName = utilityDetails["13"].name

    if (utilityDetails["75"] && utilityDetails["75"].length > 0) {
      if (utilityDetails["75"][0].name === "agreement" || utilityDetails["75"][0].name === "terms_conditions") {
        showSubscription = true
      } else {
        document.querySelector("#page_3_payment_required_consent_widget .subscription-agreement-main").style.display =
          "none"
      }
    } else {
      document.querySelector("#page_3_payment_required_consent_widget .subscription-agreement-main").style.display =
        "none"
    }

    if (utilityDetails["76"] && utilityDetails["76"].length > 0) {
      if (utilityDetails["76"][0].name === "agreement" || utilityDetails["76"][0].name === "disclosure") {
        showDisclosure = true
      } else {
        document.querySelector("#page_3_payment_required_consent_widget .disclosure-main").style.display = "none"
      }
    } else {
      document.querySelector("#page_3_payment_required_consent_widget .disclosure-main").style.display = "none"
    }

    if (utilityDetails["86"] && utilityDetails["86"].length > 0) {
      if (utilityDetails["86"][0].name === "agreement") {
        showDataConsent = true
        storage.rawSet("showDataConsent", true)
      } else {
        storage.rawSet("showDataConsent", false)
      }
    } else {
      storage.rawSet("showDataConsent", false)
    }

    if (utilityDetails["33"] === "1") {
      showPayment = true
    } else {
      document.querySelector("#page_3_payment_required_consent_widget .jnpiays-bank-credit").style.display = "none"
    }
  }

  async function updateDataConsentAgreementId(value) {
__ea_trace("modules/consent/consent-pay.ts","updateDataConsentAgreementId",[value],["value"]);
    var dealId = storage.rawGet("dealId")
    try {
      var prop = {
        properties: {
          deal_id: dealId,
          dataconsent_adobe_agreement_id: value,
        },
      }

      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        await getDataConsentAgreementUrl()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function updateMinnesotaAgreementId(value) {
__ea_trace("modules/consent/consent-pay.ts","updateMinnesotaAgreementId",[value],["value"]);
    var dealId = storage.rawGet("dealId")
    try {
      var prop = {
        properties: {
          deal_id: dealId,
          minnesota_adobe_agreement_id: value,
        },
      }

      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        await getMinnesotaAgreementUrl(value)
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function getDataConsentAgreementUrl() {
__ea_trace("modules/consent/consent-pay.ts","getDataConsentAgreementUrl",[],[]);
    var adobe_agreement_id = storage.rawGet("DataConsentagreementId")
    try {
      const endpoint = `https://api.nautilussolar.com/api/getSignatureUrl/${adobe_agreement_id}`

      const response = await fetch(endpoint, {
        method: "GET",
      })

      if (!response.ok) {
        throw new Error(`Adobe API returned status ${response.status}`)
      }

      const result = await response.json()
      const signingUrl = result.data.signingUrlSetInfos?.[0]?.signingUrls?.[0]?.esignUrl
      const iframe = document.createElement("iframe")

      iframe.src = signingUrl
      iframe.width = "750"
      iframe.height = "1000"
      iframe.style.border = "none"

      const container = document.querySelector(".dataConsentAgreement")

      container.innerHTML = ""

      container.appendChild(iframe)

      closeProgressBar()
    } catch (error) {
      closeProgressBar()
      console.error("Error in getDataConsentAgreementUrl:", error)
    }
  }
  async function getMinnesotaAgreementUrl(adobe_agreement_id) {
__ea_trace("modules/consent/consent-pay.ts","getMinnesotaAgreementUrl",[adobe_agreement_id],["adobe_agreement_id"]);
    try {
      const endpoint = `https://api.nautilussolar.com/api/getSignatureUrl/${adobe_agreement_id}`
      const response = await fetch(endpoint, {
        method: "GET",
      })
      if (!response.ok) {
        throw new Error(`Adobe API returned status ${response.status}`)
      }
      const result = await response.json()
      const signingUrl = result.data.signingUrlSetInfos?.[0]?.signingUrls?.[0]?.esignUrl

      const iframe = document.createElement("iframe")
      iframe.src = signingUrl
      iframe.width = "750"
      iframe.height = "1000"
      iframe.style.border = "none"
      const container = document.querySelector(".mnAgreement")
      container.innerHTML = ""
      container.appendChild(iframe)
      closeProgressBar()
    } catch (error) {
      closeProgressBar()
      console.error("Error in getMinnesotaAgreementUrl:", error)
    }
  }
  async function createDataConsentAdobeAgreement() {
__ea_trace("modules/consent/consent-pay.ts","createDataConsentAdobeAgreement",[],[]);
    const url = "https://api.na3.adobesign.com/api/rest/v6/agreements"

    // Build your dynamic JSON body
    const body = {
      name: `${`${storage.rawGet("LoggedName")} ${storage.rawGet("contactId")}`}`, // Change dynamically
      fileInfos: [
        {
          libraryDocumentId: "CBJCHBCAABAA8TGpNz0J5vOLybOw-urSDENkBTM9N5DN",
        },
      ],
      participantSetsInfo: [
        {
          memberInfos: [
            {
              email: `${storage.rawGet("userEmail") ?? ""}`, // Change dynamically
            },
          ],
          order: 1,
          role: "SIGNER",
        },
      ],
      mergeFieldInfo: [
        {
          fieldName: "Customer Account Number",
          defaultValue: `${storage.rawGet("uan1Value") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "UAN 2",
          defaultValue: `Prem #: ${storage.rawGet("uan2Value") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "Service Address",
          defaultValue: `${storage.rawGet("Street Address") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "City",
          defaultValue: `${storage.rawGet("city") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "State",
          defaultValue: `${storage.rawGet("FarmStateAbbreviation") ?? ""}`,
        },
        {
          fieldName: "Zip",
          defaultValue: `${storage.rawGet("zip_code") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "Name",
          defaultValue: `${storage.rawGet("LoggedName") ?? ""}`, // Change dynamically
        },
      ],
      signatureType: "ESIGN",
      state: "IN_PROCESS",
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer 3AAABLblqZhC1dTtXjAGGLK1S-DirIkemdHclBxXjGIGEuShgkiyadXjkcdGXsry5NWv8b2MK5ETTbLanqoFu8pGo0yZFqfRI",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()
      storage.rawSet("DataConsentagreementId", data.id)
      await updateDataConsentAgreementId(data.id)
    } catch (error) {
      console.error("Error creating Adobe agreement:", error)
    }
  }
  async function createMinnesotaAdobeAgreement() {
__ea_trace("modules/consent/consent-pay.ts","createMinnesotaAdobeAgreement",[],[]);
    const url = "https://api.na3.adobesign.com/api/rest/v6/agreements"
    const body = {
      name: `${`${storage.rawGet("LoggedName")} ${storage.rawGet("contactId")}`}`, // Change dynamically
      fileInfos: [
        {
          libraryDocumentId: "CBJCHBCAABAA1reh7u2P0HL-BALHcmrAm4B1Olzmage-",
        },
      ],
      participantSetsInfo: [
        {
          memberInfos: [
            {
              email: `${storage.rawGet("userEmail") ?? ""}`, // Change dynamically
            },
          ],
          order: 1,
          role: "SIGNER",
        },
      ],
      mergeFieldInfo: [
        {
          fieldName: "Account",
          defaultValue: `${storage.rawGet("uan1Value") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "Address",
          defaultValue: `${storage.rawGet("Street Address") ?? ""}, ${storage.rawGet("city") ?? ""}, MN, ${storage.rawGet("zip_code") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "MAddress",
          defaultValue: `${storage.rawGet("Street Address") ?? ""}, ${storage.rawGet("city") ?? ""}, MN, ${storage.rawGet("zip_code") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "FarmAddress",
          defaultValue: `${storage.rawGet("FarmStreetAddress1") ?? ""}, ${storage.rawGet("FarmCity") ?? ""}, ${storage.rawGet("FarmStateAbbreviation") ?? ""}, ${storage.rawGet("zip_code") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "Name",
          defaultValue: `${storage.rawGet("LoggedName") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "Name1",
          defaultValue: `${storage.rawGet("LoggedName") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "FarmName",
          defaultValue: `${storage.rawGet("FarmDisplayName") ?? ""}`, // Change dynamically
        },
      ],
      signatureType: "ESIGN",
      state: "IN_PROCESS",
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer 3AAABLblqZhC1dTtXjAGGLK1S-DirIkemdHclBxXjGIGEuShgkiyadXjkcdGXsry5NWv8b2MK5ETTbLanqoFu8pGo0yZFqfRI",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()

      storage.rawSet("MinnesotaagreementId", data.id)
      await updateMinnesotaAgreementId(data.id)
    } catch (error) {
      console.error("Error creating Adobe agreement:", error)
    }
  }
  async function sendDataConsentAgreementIdToGetStatus() {
__ea_trace("modules/consent/consent-pay.ts","sendDataConsentAgreementIdToGetStatus",[],[]);
    var _dealId = storage.rawGet("dealId")
    var dataConsentId = storage.rawGet("DataConsentagreementId")
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/agreementstatus/${dataConsentId}`
      const response = await fetch(hubDBEndpoint, {
        method: "GET",
      })
      const res = await response.json()

      if (res.data.status === "OUT_FOR_SIGNATURE") {
        alert("Please sign the agreement to proceed.")
        await getDataConsentAgreementUrl()
        closeProgressBar()
      } else if (res.data.status === "SIGNED") {
        openProgressBar("We are loading your payment options")
        storage.rawSet("dataConsentSignatureStatus", "SIGNED")
        await updateDataConsentAdobeUrl(res.url, res.hubspot.url, res.hubspot.id, "SIGNED")
      } else {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function sendMinnesotaAgreementIdToGetStatus() {
__ea_trace("modules/consent/consent-pay.ts","sendMinnesotaAgreementIdToGetStatus",[],[]);
    var _dealId = storage.rawGet("dealId")
    var mnId = storage.rawGet("MinnesotaagreementId")
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/agreementstatus/${mnId}`
      const response = await fetch(hubDBEndpoint, {
        method: "GET",
      })
      const res = await response.json()
      if (res.data.status === "OUT_FOR_SIGNATURE") {
        alert("Please sign the agreement to proceed.")
        await getMinnesotaAgreementUrl(mnId)
        closeProgressBar()
      } else if (res.data.status === "SIGNED") {
        openProgressBar("We are loading your payment options")
        storage.rawSet("mnSignatureStatus", "SIGNED")
        await updateMinnesotaAdobeUrl(res.url, res.hubspot.url, res.hubspot.id, "SIGNED")
      } else {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function updateDataConsentAdobeUrl(_value, value1, value2, value3) {
__ea_trace("modules/consent/consent-pay.ts","updateDataConsentAdobeUrl",[_value,value1,value2,value3],["_value","value1","value2","value3"]);
    var dealId = storage.rawGet("dealId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          saa_document_sub_type_3: utilityDetails["86"][0].label,
          lmi_saa_doc_file_3: value1,
          saa_doc_file_3_id: value2,
          data_consent_document_status: value3,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        document.querySelector(".jnpiays-main").style.display = "block"
        document.querySelector(".dataConsentAgreement").style.display = "none"
        document.querySelector("#firstStepButton").style.display = "none"
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function updateMinnesotaAdobeUrl(_value, value1, value2, value3) {
__ea_trace("modules/consent/consent-pay.ts","updateMinnesotaAdobeUrl",[_value,value1,value2,value3],["_value","value1","value2","value3"]);
    var dealId = storage.rawGet("dealId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          saa_document_sub_type_2: utilityDetails["76"][0].label,
          lmi_saa_doc_file_2: value1,
          saa_doc_file_2_id: value2,
          minnesota_document_status: value3,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        document.querySelector(".jnpiays-main").style.display = "block"
        document.querySelector(".dataConsentAgreement").style.display = "none"
        document.querySelector("#firstStepButton").style.display = "none"
        document.querySelector(".mnAgreement").style.display = "none"
        document.querySelector("#mnfirstStepButton").style.display = "none"
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }

  document.querySelector("#firstStepButton").addEventListener("click", async () => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[],[]);
    openProgressBar("We are saving your signed document to your account")
    await sendDataConsentAgreementIdToGetStatus()
  })
  document.querySelector("#mnfirstStepButton").addEventListener("click", async () => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[],[]);
    openProgressBar("We are saving your signed document to your account")
    await sendMinnesotaAgreementIdToGetStatus()
  })

  // Token values per state. Kinds are split because the documents disagree
  // on date format and on whether the signer or account-holder name prints.
  function getAgreementValues(state) {
__ea_trace("modules/consent/consent-pay.ts","getAgreementValues",[state],["state"]);
    switch (state) {
      case "Maryland":
        return {
          subscription: {
            effectiveDate: formattedDate3 ?? "",
            email: loggedEmail ?? "",
            lmiDiscount: lmiDiscount ?? "",
            primaryPhone: loggedHomePhone ?? loggedCellPhone ?? "",
            serviceAddress: loggedAddress ?? "",
            standardDiscount: standardDiscount ?? "",
            subscriberName: loggedName ?? "",
            subscriberTitle: userTitle ?? "",
            utilityAccountNumber: utilityAccountNumber ?? "",
          },
        }
      case "Maine":
        return {
          subscription: {
            signedDate: formattedDate ?? "",
            subscriberName: subscriptionSignedName ?? "",
            utilityLogoUrl: SessionLogo ?? "",
          },
          disclosure: {
            projectAddressLine1: Farm_LLC_Address1 ?? "",
            projectAddressLine2: Farm_LLC_Address2 ?? "",
            projectCity: Farm_LLC_City ?? "",
            projectCompanyName: Farm_LLC ?? "",
            projectDescription: Farm_Project_Description ?? "",
            projectEmail: Farm_LLC_Email ?? "",
            projectPhone: Farm_Phone_Number ?? "",
            projectState: Farm_LLC_State ?? "",
            projectZip: Farm_LLC_Zip ?? "",
          },
        }
      case "Delaware":
        return {
          subscription: {
            email: loggedEmail ?? "",
            lmiDiscount: lmiDiscount ?? "",
            primaryPhone: loggedHomePhone ?? loggedCellPhone ?? "",
            signedDate: formattedDate2 ?? "",
            subscriberName: loggedName ?? "",
            subscriberSignatureName: subscriptionSignedName ?? "",
          },
        }
      case "Colorado":
        return {
          subscription: {
            alternatePhone: loggedCellPhone ?? loggedHomePhone ?? "",
            email: loggedEmail ?? "",
            primaryPhone: loggedHomePhone ?? loggedCellPhone ?? "",
            projectAddressLine1: Farm_LLC_Address1 ?? "",
            projectAddressLine2: Farm_LLC_Address2 ?? "",
            projectCompanyName: Farm_LLC ?? "",
            projectDisplayName: Farm_Display_Name ?? "",
            projectId: Farm_LLC_Id ?? "",
            retailCustomerNumber: retailCustomerNumber ?? "",
            serviceAddress: loggedAddress ?? "",
            serviceState: loggedState ?? "",
            serviceZip: loggedZip ?? "",
            signedDate: formattedDate2 ?? "",
            subscriberName: subscriptionSignedName ?? "",
          },
          disclosure: {
            signedDate: formattedDate2 ?? "",
            subscriberName: loggedName ?? "",
          },
        }
      case "Minnesota":
        return {
          subscription: {
            serviceAddress: loggedAddress ?? "",
            serviceCounty: loggedCounty ?? "",
            serviceState: loggedState ?? "",
            serviceZip: loggedZip ?? "",
            signedDate: formattedDate2 ?? "",
            subscriberName: subscriptionSignedName ?? "",
            utilityAccountNumber: storage.rawGet("uan1Value") ?? "",
          },
        }
      case "Rhode Island":
        return {
          subscription: {
            customerName: String(loggedName),
            email: String(loggedEmail),
            primaryPhone: String(loggedHomePhone ?? loggedCellPhone),
            serviceCity: String(loggedCity),
            serviceState: String(loggedState),
            serviceStreetAddress: String(streetAddress),
            serviceZip: String(loggedZip),
            signedDate: String(formattedDaterh),
            signedTimestamp: String(formattedDateStamprh),
            subscriberSignatureName: String(subscriptionSignedName),
            utilityAccountNumber: String(storage.rawGet("uan1Value") ?? ""),
          },
        }
      default:
        return { subscription: {}, disclosure: {} }
    }
  }

  // currently working functions below
  var finalSubTemp
  var finalDisclosureTemp
  var _finalDataConsentTemp

  var subDocDownloadName = "subscription_agreement.pdf"
  var disbDocDownloadName = "Disclosure.pdf"
  async function setTemplates() {
__ea_trace("modules/consent/consent-pay.ts","setTemplates",[],[]);
    if (stageName === "Delaware") {
      IsValidateDisclosure = false
      const element = document.getElementById("disclosure")
      if (element) {
        element.style.display = "none"
      }
    }
    if (stageName === "Minnesota") {
      subDocDownloadName = "Subscription Agreement Signature"
    }

    var agreements = await loadStateAgreements(root, stageName, getAgreementValues(stageName))
    finalSubTemp = agreements.subscription
    finalDisclosureTemp = agreements.disclosure
  }

  var templateGate = createTemplateGate(setTemplates)
  var ensureTemplatesReady = templateGate.ensureReady
  var discPreviewWindow
  var subPreviewWindow
  var _dataConsentPreviewWindow

  async function previewSubTemplate() {
__ea_trace("modules/consent/consent-pay.ts","previewSubTemplate",[],[]);
    if (!(await ensureTemplatesReady())) return
    if (discPreviewWindow && !discPreviewWindow.closed) {
      discPreviewWindow.close()
    }

    subPreviewWindow = window.open("", "SubPreview", "width=600,height=400")

    subPreviewWindow.document.write(finalSubTemp)
  }
  async function previewDiscTemplate() {
__ea_trace("modules/consent/consent-pay.ts","previewDiscTemplate",[],[]);
    if (!(await ensureTemplatesReady())) return

    if (subPreviewWindow && !subPreviewWindow.closed) {
      subPreviewWindow.close()
    }

    discPreviewWindow = window.open("", "DiscPreview", "width=600,height=400")

    discPreviewWindow.document.write(finalDisclosureTemp)
  }
  async function savePdfDisclosure() {
__ea_trace("modules/consent/consent-pay.ts","savePdfDisclosure",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return

      var container = document.createElement("div")
      container.innerHTML = finalDisclosureTemp
      document.body.appendChild(container)

      await html2pdf()
        .from(container)
        .set({
          margin: 10,
          filename: `${disbDocDownloadName}`,
          html2canvas: { scale: 2, useCORS: true },
        })
        .save()
      document.body.removeChild(container)
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }
  async function savePdfSubAgreement() {
__ea_trace("modules/consent/consent-pay.ts","savePdfSubAgreement",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return

      var container = document.createElement("div")
      container.className = "pdfTemplate"
      container.innerHTML = finalSubTemp

      document.body.appendChild(container)
      if (stageName === "Rhode Island") {
        // Configure and save the PDF
        await html2pdf()
          .from(container)
          .set({
            margin: [20, 0, 80, 0], // Set margins
            filename: `${subDocDownloadName}`,
            html2canvas: {
              scale: 2, // Adjust scale for content size
              logging: true,
              letterRendering: true,
            },
            jsPDF: {
              unit: "pt",
              format: "a4",
              orientation: "portrait",
            },
          })
          .save()
      } else {
        await html2pdf()
          .from(container)
          .set({
            margin: [10, 10, 10, 10], // Set margins
            filename: `${subDocDownloadName}`,
            html2canvas: {
              scale: 2, // Adjust scale for content size
              logging: true,
              letterRendering: true,
            },

            jsPDF: {
              unit: "pt",
              format: "a4",
              orientation: "portrait",
            },
          })
          .save()
      }

      document.body.removeChild(container)
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }

  var SubAgreementUrl = ""
  var DiscAgreementUrl = ""
  var _DataConsentAgreementUrl = ""
  var SubAgreementId = ""
  var DiscAgreementId = ""
  var _DataConsentAgreementId = ""
  async function _isPdfBlank(pdfBlob) {
__ea_trace("modules/consent/consent-pay.ts","_isPdfBlank",[pdfBlob],["pdfBlob"]);
    const loadingTask = pdfjsLib.getDocument({ data: await pdfBlob.arrayBuffer() })
    const pdfDocument = await loadingTask.promise
    const numPages = pdfDocument.numPages

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdfDocument.getPage(pageNum)

      const textContent = await page.getTextContent()

      if (textContent.items.length > 0) {
        return false
      }
    }

    return true
  }
  async function uploadPdf() {
__ea_trace("modules/consent/consent-pay.ts","uploadPdf",[],[]);
    utilityAccountNumber = storage.rawGet("uan1Value") ?? ""
    _utilityAccountNumber2 = storage.rawGet("uan2Value") ?? ""
    if (!(await ensureTemplatesReady())) return

    await convertAndUploadPdf(finalSubTemp, true, false)
    if (
      stageName !== "Delaware" &&
      stageName !== "Maryland" &&
      stageName !== "Minnesota" &&
      stageName !== "Rhode Island"
    ) {
      await convertAndUploadPdf(finalDisclosureTemp, false, false)
    }
  }

  //new here
  var isSubBlank = null
  var isDisBlank = null
  var _isDataConsentBlank = false
  async function convertAndUploadPdf(template, isSubAgreement, isDataConsentAgreement) {
__ea_trace("modules/consent/consent-pay.ts","convertAndUploadPdf",[template,isSubAgreement,isDataConsentAgreement],["template","isSubAgreement","isDataConsentAgreement"]);
    return new Promise(async (resolve, reject) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[resolve,reject],["resolve","reject"]);
      try {
        var container = document.createElement("div")
        container.innerHTML = template
        document.body.appendChild(container)

        var isPdfBlank = false

        const pdfCanvas = await html2canvas(container, { scale: 2 })
        if (isSubAgreement) {
          isSubBlank = checkIfCanvasIsBlank(pdfCanvas)
          isPdfBlank = isSubBlank
        } else {
          isDisBlank = checkIfCanvasIsBlank(pdfCanvas)
          isPdfBlank = isDisBlank
        }

        if (isPdfBlank) {
          document.body.removeChild(container)

          if (isSubAgreement) {
            console.error("Error in generating Subscription agreement please try again later")
          } else {
            console.error("Error in generating disclosure agreement please try again later")
          }
        }
        if (stageName === "Rhode Island") {
          await html2pdf()
            .from(container)
            .set({
              margin: 10,
              filename: "template.pdf",
              html2canvas: {
                scale: 2,
                useCORS: true,
              },
              jsPDF: { unit: "pt", format: [900, 841.89], orientation: "portrait" },
              pagebreak: { mode: ["css", "avoid-all"] },
            })
            .toPdf()
            .output("blob")
            .then((pdfBlob) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[pdfBlob],["pdfBlob"]);
              var pdfFile = new File(
                [pdfBlob],
                isDataConsentAgreement
                  ? "DataConsentagreement.pdf"
                  : isSubAgreement
                    ? "Subagreement.pdf"
                    : "Disclosure.pdf",
                { type: "application/pdf" },
              )

              var formData = new FormData()
              formData.append("file", pdfFile)

              fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[response],["response"]);
                  if (response.ok) {
                    response
                      .json()
                      .then((result) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[result],["result"]);
                        if (isSubAgreement) {
                          SubAgreementUrl = result.response.url
                        } else {
                          DiscAgreementUrl = result.response.url
                        }
                        resolve()
                      })
                      .catch((error) => reject(error))
                  } else {
                    reject(
                      new Error(
                        `Error uploading ${isSubAgreement ? "sub" : isDataConsentAgreement ? "dataCon" : "disc"} agreement file. Status: ${response.status}`,
                      ),
                    )
                  }
                })
                .catch((error) => reject(error))
            })
            .catch((error) => reject(error))
        } else {
          await html2pdf()
            .from(container)
            .set({
              margin: 10,
              filename: "template.pdf",
              html2canvas: {
                scale: 2,
                useCORS: true,
              },
              jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
              pagebreak: { mode: ["css", "avoid-all"] },
            })
            .toPdf()
            .output("blob")
            .then((pdfBlob) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[pdfBlob],["pdfBlob"]);
              var pdfFile = new File(
                [pdfBlob],
                isDataConsentAgreement
                  ? "DataConsentagreement.pdf"
                  : isSubAgreement
                    ? "Subagreement.pdf"
                    : "Disclosure.pdf",
                { type: "application/pdf" },
              )

              var formData = new FormData()
              formData.append("file", pdfFile)

              fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[response],["response"]);
                  if (response.ok) {
                    response
                      .json()
                      .then((result) => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[result],["result"]);
                        if (isSubAgreement) {
                          SubAgreementUrl = result.response.url
                          SubAgreementId = result.response.id
                        } else {
                          DiscAgreementUrl = result.response.url
                          DiscAgreementId = result.response.id
                        }
                        resolve()
                      })
                      .catch((error) => reject(error))
                  } else {
                    reject(
                      new Error(
                        `Error uploading ${isSubAgreement ? "sub" : "disc"} agreement file. Status: ${response.status}`,
                      ),
                    )
                  }
                })
                .catch((error) => reject(error))
            })
            .catch((error) => reject(error))
        }
        document.body.removeChild(container)
      } catch (e) {
        console.error("Error in convertAndUploadPdf:", e)
        reject(e)
      }
    })
  }
  function checkIfCanvasIsBlank(canvas) {
__ea_trace("modules/consent/consent-pay.ts","checkIfCanvasIsBlank",[canvas],["canvas"]);
    const context = canvas.getContext("2d")
    const pixelData = context.getImageData(0, 0, canvas.width, canvas.height).data

    for (let i = 0; i < pixelData.length; i += 4) {
      const [r, g, b, a] = pixelData.slice(i, i + 4)
      if (a !== 0 && (r !== 255 || g !== 255 || b !== 255)) {
        return false
      }
    }
    return true
  }

  async function _printDisclosure() {
__ea_trace("modules/consent/consent-pay.ts","_printDisclosure",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return
      var customHTML = finalDisclosureTemp

      var iframe = document.createElement("iframe")
      iframe.style.width = "0"
      iframe.style.height = "0"
      document.body.appendChild(iframe)

      iframe.contentDocument.write(customHTML)
      iframe.contentDocument.close()

      iframe.contentWindow.print()
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }
  async function printDisclosure() {
__ea_trace("modules/consent/consent-pay.ts","printDisclosure",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return
      var customHTML = finalDisclosureTemp

      // Create an iframe
      var iframe = document.createElement("iframe")
      iframe.style.width = "0"
      iframe.style.height = "0"
      iframe.style.border = "none"
      document.body.appendChild(iframe)

      iframe.contentDocument.write(customHTML)
      iframe.contentDocument.close()

      iframe.onload = () => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[],[]);
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
        setTimeout(() => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[],[]);
          document.body.removeChild(iframe)
        }, 1000)
      }
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }

  setTimeout(() => {
__ea_trace("modules/consent/consent-pay.ts","(anon)",[],[]);
    pageloaded = true
  }, 5000)

  // pdf and print ---------------------------------------------------------------------

  var is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")

  // ─── Wire formerly-inline handlers ────────────────────────────────────────────

  // Payment type radio buttons
  bind("#ACH", "click", () => showContent("bank"))
  bind("#CreditCard", "click", () => showContent("credit"))

  // Soft credit-check checkbox
  bind("#softCheck", "change", () => toggleDivVisibility())

  // Agreement preview popups
  bind("#sa-view-a-copy-anchor", "click", () => previewSubTemplate())
  bind("#dsc-view-a-copy-anchor", "click", () => previewDiscTemplate())
}
